"use client";
import { jsx as e, jsxs as r } from "react/jsx-runtime";
import s from "clsx";
import i from "next/image";
import { memo as h, forwardRef as d } from "react";
import { Box as n } from "../../base/Base.js";
import { s as o } from "../../../UploadedPhotoBlock.module-NQCKFqNv.js";
const p = ({ srcFrom: a, srcTo: l, blur: t, children: m }, c) => /* @__PURE__ */ e(n, { gap: 0, className: o.photo_block, ref: c, children: /* @__PURE__ */ r(n, { gap: 0, className: o.photo_inner, children: [
  /* @__PURE__ */ r("div", { className: o.photo_box, children: [
    /* @__PURE__ */ e(
      i,
      {
        src: a,
        alt: "image",
        fill: !0,
        className: s(o.content, o.content__from, {
          [o.blur]: t
        }),
        unoptimized: !0
      }
    ),
    /* @__PURE__ */ e(
      i,
      {
        src: l,
        alt: "image",
        fill: !0,
        className: s(o.content, o.content__to, {
          [o.blur]: t
        }),
        unoptimized: !0
      }
    ),
    /* @__PURE__ */ r("div", { className: o.anim_arrow_box, children: [
      /* @__PURE__ */ e(
        "svg",
        {
          className: o.anim_arrow_line,
          width: "175",
          height: "45",
          viewBox: "0 0 175 45",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ e(
            "path",
            {
              d: "M4 40.9999C48.7681 -8.08514 125.729 -8.58101 171 40.9999",
              stroke: "#E86F00",
              "stroke-width": "8",
              "stroke-linecap": "round"
            }
          )
        }
      ),
      /* @__PURE__ */ e(
        "svg",
        {
          className: o.anim_arrow_head,
          width: "32",
          height: "32",
          viewBox: "0 0 32 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ e(
            "path",
            {
              d: "M28 4V28H4",
              stroke: "#E86F00",
              "stroke-width": "8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          )
        }
      )
    ] })
  ] }),
  m
] }) }), w = h(
  d(
    p
  )
);
w.displayName = "ProcessingPhotoBlock";
export {
  p as InternalProcessingPhotoBlock,
  w as ProcessingPhotoBlock
};
